
  <!-- <button mat-flat-button class="float-right fdm-button" style="margin-top:5px;margin-right:5px;" *ngIf="mapService?.canWrite" color="primary" (click)="browsePhotos()" [matTooltip]="'MAP.ADD_PICS' | translate">
      <fa-icon class="text-white" [icon]="['far','plus']"></fa-icon>
  </button> -->

    <cdk-virtual-scroll-viewport id="photo-bucket-viewport" orientation="horizontal" class="pointer fdm-horizontal-viewport" itemSize="140" minBufferPx="200" maxBufferPx="800">

      <ng-container *cdkVirtualFor="let imgs of imagesGrouped">
        <div class="image-group">
          <image-cell *ngFor="let cur of imgs" (onClick)="setSelected(cur)" [image]="cur"></image-cell>
        </div>
      </ng-container>
      
      <div *ngIf="!images.length">
        <p>{{ 'MAP.PHOTOGRAM.NO_IMAGES' | translate }}</p>
        <button mat-flat-button class="fdm-button" style="margin-top:5px;margin-right:5px;" *ngIf="mapService?.canWrite" color="primary" (click)="browsePhotos()" [matTooltip]="'MAP.ADD_PICS' | translate">
            <fa-icon class="text-white" [icon]="['far','plus']"></fa-icon> {{ 'MAP.ADD_PICS' | translate }}
        </button>
      </div>

    </cdk-virtual-scroll-viewport>

    

      <!--<div *ngFor="let cur of images" class="p-2 pointer"  [ngClass]="{'primary-bg-light':cur == selected}">
                                                                      &lt;!&ndash;mapComp.showDZI(cur)&ndash;&gt;
          <image-cell (onClick)="setSelected(cur)" [image]="cur"></image-cell>
      </div>-->





  <!--   



      <h5 *ngIf="imageComp.images.length < 1">{{'MAP.ERROR.NO_PHOTOS' | translate }}</h5>
      <cdk-virtual-scroll-viewport orientation="horizontal" class="pointer fdm-horizontal-viewport" itemSize="140">
        <ng-container *cdkVirtualFor="let cur of imageComp.images">
          <div class="item">
            <image-cell (onClick)="imageComp.setSelected(cur)" [image]="cur"></image-cell>
          </div>
        </ng-container>
      </cdk-virtual-scroll-viewport>
 
  -->
